<template>
    <div class="modal-container">
        <div class="modal-body">
            <div class="top-row">
                <div class="text">
                    <p>Welcome!</p>
                    <p>
                        We're glad you're here! Before you continue, let's set a few preferences to improve your experience on our marketplace. By clicking "Sure, go ahead", you agree to our use of cookies to make your visit more enjoyable and personalized. This helps us offer you tailored product recommendations and relevant marketing content. Enjoy your time with Gambody, and thank you for choosing us!
                    </p>
                </div>

                <div class="lvl1-buttons">
                    <a href="#" @click.prevent="toggleCustomization">Prefer to customize your settings?</a>
                    <button @click="acceptAll" class="btn btn-green btn-lg" :disabled="customizationOpen">Sure, go ahead</button>
                </div>
            </div>

            <c-cookie-management v-if="customizationOpen" :cookies="cookies" :privacy-url="privacyUrl" />
        </div>
    </div>
</template>

<script>
import CookieManagement from "./cookie-management.vue";

export default {
    name: "cookieBanner",

    props: {
        cookies: {
            required: true,
            type: Array
        },
        privacyUrl: {}
    },

    components: {
        "c-cookie-management": CookieManagement
    },

    data() {
        return {
            customizationOpen: false,
        }
    },

    methods: {
        setCookie(cookies) {
            document.cookie = "cookies_allowed=" + cookies.join(",") + ";max-age=" + 365*24*60*60 + ";";
        },

        acceptAll() {
            this.setCookie(["analytics"]);
            window.location.reload();
        },

        toggleCustomization() {
            this.customizationOpen = !this.customizationOpen;
        },
    }
}
</script>

<style scoped>

.modal-container {
    width: 100%;
    height: 100%;
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0, 0.5);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.modal-body {
    background-color: white;
    top: 30rem;
    margin: auto;
    border-radius: 0.5rem;
    padding: 1rem;
    display: flex;
    flex-direction: column;
    gap: 2rem;
    font-size: 0.9rem;
}

@media (min-width: 1000px) {
    .modal-body {
        width: 800px;
    }
}

.lvl1-buttons {
    display: flex;
    align-items: center;
    justify-content: space-around;
}

.lvl1-buttons a {
    color: saddlebrown;
    text-decoration: underline;
}


.top-row {
    display: flex;
    flex-direction: column;
    gap:1rem;
}
.btn-lg {
    font-size: 1.15rem;
}

</style>
